import { render, staticRenderFns } from "./tab_seguridad.vue?vue&type=template&id=495dbbc3&scoped=true"
import script from "./tab_seguridad.vue?vue&type=script&lang=js"
export * from "./tab_seguridad.vue?vue&type=script&lang=js"
import style0 from "./tab_seguridad.vue?vue&type=style&index=0&id=495dbbc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495dbbc3",
  null
  
)

export default component.exports